import { TemplateData, TemplateParams } from '.';

const calendarEventFillFromQueue = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'calendar-events',
  email: {
    buttonEnabled: true,
    buttonLink: '{{eventUrl}}',
    buttonText: messages.eventCalendarEventPage,
    content: `
      <p>
        ${messages.calendarEventFillFromQueueInfo}
        ${messages.calendarEventAccessEventPage}
      </p>`,
    contentAfterButton: `
      ${
        serverConfig.authEnableLocalLogin &&
        !serverConfig.emailHidePasswordResetInfo
          ? `<p>${messages.emailResetPasswordContent}</p>`
          : ''
      }
      <p>
        ${messages.emailSignatureText}
      </p>`,
    heading: messages.emailGreeting,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    subject: `{{siteName}}: ${messages.calendarEventAddedToEvent}`
  },
  placeholders: {
    eventTime: {
      label: messages.calendarEventDateAndTime,
      example: '27.3.2024 08:00 - 10:00'
    },
    eventTitle: {
      label: messages.calendarEventTitle,
      example: 'Test event'
    },
    eventUrl: {
      label: messages.calendarEventLink,
      example: `${serverConfig.adminUrl}/calendar/1`
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeCalendarEventFillFromQueue
});

export default calendarEventFillFromQueue;
